export const LoginIcon = () => {
  return (
    <img
      src="assets/images/logo-login.png"
      alt=""
      className="logo_login_icon"
    />
  );
};

export const EyeIcon = () => {
  return (
    <img src="assets/images/eye.svg" alt="eye" className="table_action_icons" />
  );
};
export const DeleteIcon = () => {
  return (
    <img
      src="assets/images/trash.svg"
      alt="eye"
      className="table_action_icons"
    />
  );
};
export const CheckIcon = () => {
  return (
    <img
      src="assets/images/check.svg"
      alt="eye"
      className="table_action_icons"
    />
  );
};

export const CloseIcon = () => {
  return (
    <img
      src="assets/images/close.svg"
      alt="eye"
      className="table_action_icons"
    />
  );
};
export const EditIcon = () => {
  return (
    <img
      src="assets/images/edit.png"
      alt="eye"
      className="table_action_icons"
    />
  );
};
